<template>
  <div class="myinfo-wallet-box">
    <div class="wallet-box-item" style="margin-bottom: 32px">
      <div class="profile-title">
        <div>My balance</div>

        <div class="my-coupons" @click="toMyCoupons">
          My coupons<i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div style="display: flex; margin-top: 20px">
        <div class="cash-item">
          <div class="cash-item-name">Revenue</div>
          <div class="cash-item-value">
            C${{ (userInfo.leijitixian / 100).toFixed(2) }}
          </div>
        </div>

        <!-- <div class="cash-item">
          <div class="cash-item-name">To be Settled</div>
          <div class="cash-item-value">
            C${{ (userInfo.daijiesuan / 100).toFixed(2) }}
          </div>
        </div> -->

        <div class="cash-item">
          <div class="cash-item-name">Cashable</div>
          <div class="cash-item-value">
            C${{ (userInfo.ketixian / 100).toFixed(2) }}
          </div>
        </div>

        <div class="cash-item" style="float: end">
          <div class="cash-item-name"></div>
          <el-button class="cash-out-button" @click="toCashDetail"
            >Cash out</el-button
          >
        </div>
      </div>
    </div>

    <div class="wallet-box-item" style="height: 100%">
      <div class="profile-title">Balance Details</div>
      <el-table :data="accountRecordlist" style="width: 100%">
        <el-table-column label="No" type="index"></el-table-column>
        <el-table-column label="OrderID" prop="orderId"></el-table-column>
        <el-table-column label="ClassID" prop="calendarId"></el-table-column>
        <el-table-column label="Money" prop="money">
          <template slot-scope="scope">
            {{
              ([1, 3, 5, 6].includes(scope.row.type) ? "+" : "-") +
              (scope.row.money / 100).toFixed(2)
            }}
          </template>
        </el-table-column>
        <el-table-column label="Type">
          <template slot-scope="scope">
            {{ type_map[scope.row.type] }}
          </template>
        </el-table-column>
        <el-table-column label="Cashable">
          <template slot-scope="scope">
            {{ (scope.row.ketixian / 100).toFixed(2) }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="To be Settled">
          <template slot-scope="scope">
            {{ (scope.row.daijiesuan / 100).toFixed(2) }}
          </template>
        </el-table-column> -->
        <el-table-column label="remark" prop="remark"></el-table-column>

        <el-table-column label="operation"></el-table-column>
        <el-table-column label="time">
          <template slot-scope="scope">
            {{ format(scope.row.create_time, "ddd, MMM. Do, YYYY hh:mm A") }}
          </template>
        </el-table-column>
      </el-table>
      <KtPag
        style="text-align: right"
        :pageCount="accountRecordForm.count"
        :currentPage="accountRecordForm.page"
        :limit="accountRecordForm.limit"
        @onChange="onPageChange"
      ></KtPag>
    </div>
  </div>
</template>

<script>
import { format } from "@/utils/comm";
import { mapState, mapGetters } from "vuex";
import ValidateButton from "@/views/Pc/Component/ValidateButton";

import KtPag from "@/views/Comm/KtPag";

export default {
  components: {
    ValidateButton,
    KtPag,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo,
    }),
  },
  data() {
    return {
      queryStr: "",
      accountRecordlist: [],
      format: format,
      type_map: {
        1: "settlement",
        2: "cash-out",
        3: "recharge",
        4: "pay payment",
        5: "partial refundable",
        6: "refund",
        7: "penalty",
      },
      accountRecordForm: {
        page: 1,
        limit: 10,
        count: 0,
      },
    };
  },
  mounted() {
    this.$store.dispatch("REFRESH_USER_INFO");
    this.getAccoutRecord();
    // this.getPaypal();
  },
  methods: {
    toMyCoupons() {
      if (this.userInfo.usertype === 1) {
        this.$router.push("/groupInfo/coupons");
      } else {
        this.$router.push("/myinfo/coupons");
      }
    },
    toCashDetail() {
      if (this.userInfo.usertype === 1) {
        this.$router.push("/groupInfo/cashdetail");
      } else {
        this.$router.push("/myinfo/cashdetail");
      }
    },
    getAccoutRecord() {
      let params = { ...this.accountRecordForm };
      this.$api.accountApi.getAccoutRecord(params).then((res) => {
        if (res.status === "0") {
          this.accountRecordlist = res.data.rows;
          this.accountRecordForm.count = res.data.count;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onPageChange({ page, limit }) {
      this.accountRecordForm.page = page;
      this.accountRecordForm.limit = limit;
      this.getAccoutRecord();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.myinfo-wallet-box {
  .wallet-box-item {
    box-sizing: border-box;
    background-color: #fff;
    width: 100%;
    padding: 24px;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    .profile-title {
      height: 25px;
      font-size: 18px;
      font-weight: normal;
      color: #181d2c;
      line-height: 25px;
      display: flex;
      justify-content: space-between;
      .my-coupons {
        cursor: pointer;
        color: #f48c06;
        font-size: 14px;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .cash-item {
      margin-right: 120px;
      .cash-item-name {
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: #181d2c;
        line-height: 20px;
      }
      .cash-item-value {
        margin-top: 8px;
        height: 50px;
        font-size: 36px;
        font-weight: 600;
        color: #f48c06;
        line-height: 50px;
      }
      .cash-out-button {
        margin-top: 10px;
        background: #f48c06;
        border: none;
        color: #fff;
        &:hover {
          opacity: 0.54;
        }
        // vertical-align: baseline;
      }
    }
  }
}
</style>